import Hero from "../../components/Hero/Hero";
import FeaturedCollections from "../../components/FeaturedCollections/FeaturedCollections";
import NewArrivals from "../../components/NewArrivals/NewArrivals";
import ShopReels from "../../components/ShopReels/ShopReels";
import BrandStory from "../../components/BrandStory/BrandStory";
import SignatureCollection from "../../components/SignatureCollection/SignatureCollection"
import RareExclusive from "../../components/RareExclusive/RareExclusive";
import Testimonials from "../../components/Testimonials/Testimonials";
import VideoCallButton from "../../components/VideoCallButton";

function Home() {
  return (
    <>
      <Hero />
      <FeaturedCollections />
      <NewArrivals />
      <ShopReels/>
      <BrandStory />
      <SignatureCollection />
     <RareExclusive />
     <Testimonials />
      <VideoCallButton />
    </>
  );
}

export default Home;